module.exports = __webpack_public_path__ + "static/media/redo.3699d070.svg";